module.exports = __webpack_public_path__ + "static/images/cartoon.a6401fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cartoon.png
// module id = OHaz
// module chunks = 0